<!--main container-->
<div class="main-container" [class.login-mode]="isLoginRoute()">
  <sjp-loader />
  <sjp-header [isLoginView]="isLoginRoute()" />
  <router-outlet></router-outlet>
</div>
